/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import './Sidebar.scss';

export default function Sidebar(props) {
    return (
        <div id="library-sidebar" className={!props.showing ? 'hidden-sidebar' : null}>
            {props.children}
        </div>
    );
}
